var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPreview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.9 2.3v2.4a.55.55 0 1 0 1.1 0V1a1 1 0 0 0-1-1H9.3a.55.55 0 1 0 0 1.1h2.4a.19.19 0 0 1 .135.326l-3.33 3.33a.55.55 0 1 0 .778.778l3.346-3.346c.1-.1.271-.03.271.112"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.7 7.875a.55.55 0 0 0-.55.55V12a.9.9 0 0 1-.9.9H2a.9.9 0 0 1-.9-.9V3.75a.9.9 0 0 1 .9-.9h3.575a.55.55 0 1 0 0-1.1H2a2 2 0 0 0-2 2V12a2 2 0 0 0 2 2h8.25a2 2 0 0 0 2-2V8.425a.55.55 0 0 0-.55-.55"
})));
export { SvgIconPreview as ReactComponent };